//モジュールのインポート
import 'jquery.easing';  //jquery.easing読み込み
import script_boxAnimation from './modules/script_boxAnimation';      //ボックスアニメーション読み込み
import script_loadingSplash from './modules/script_loadingSplash';    //ローディング（スプラッシュ）読み込み
import script_burgerMenu from './modules/script_burgerMenu';          //ハンバーガーメニュー読み込み
import script_telNonPc from './modules/script_telNonPc';              //PC電話発信なし読み込み
import script_hero from './modules/script_hero';                      //通常ページヒーローアニメーション読み込み
import script_tabAccordion from './modules/script_tabAccordion';      //タブアコーディオン読み込み
import script_fadeinLeft from './modules/script_fadeinLeft';          //フェードインレフトアニメーション読み込み
import script_fadeinRight from './modules/script_fadeinRight';        //フェードインライトアニメーション読み込み
import script_randomTile from './modules/script_randomTile';          //ランダムにタイル配置するjs読み込み
import 'textillate/jquery.textillate';                        //jquery.textillate読み込み
import 'textillate/assets/jquery.lettering';                  //jquery.lettering読み込み
import 'textillate/assets/animate.css';                       //animate.css読み込み
import script_textillate from './modules/script_textillate';  //script_textillate読み込み
//import script_masonryRandom from './modules/script_masonryRandom';  //script_masonryRandom読み込み

//モジュール先にある関数実行
script_boxAnimation();    //ボックスアニメーションスクリプト実行
script_loadingSplash();   //ローディング（スプラッシュ）スクリプト実行
script_burgerMenu();      //ハンバーガーメニュースクリプト実行
script_telNonPc();        //PC電話発信なしスクリプト実行
script_hero();            //通常ページヒーローアニメーションスクリプト実行
script_tabAccordion();    //タブアコーディオンスクリプト実行
script_fadeinLeft();      //フェードインレフトアニメーション読み込み
script_fadeinRight();     //フェードインライトアニメーションスクリプト実行
script_randomTile();      //ランダムにタイル配置するjsスクリプト実行
script_textillate();      //テキストアニメーションスクリプト実行
//script_masonryRandom();  //Masonry（ランダム配置）実行
